import React from "react";

import Chip from "@busbud/design-system-components/dist/Chip/Chip";

import { useAppContext } from "@app/helpers/hooks";

import { useStyles } from "./or-chip.styles";

export const OrChip: React.FC = () => {
  const { translator } = useAppContext();
  const { classes } = useStyles();

  return (
    <Chip
      size="sm"
      color="neutral"
      variant="outlined"
      label={translator.t("!account.signin.or").toUpperCase()}
      classes={{ root: classes.chip }}
    />
  );
};
